var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileQuotas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4932 6.73012H15.1574M12.4932 8.46537H15.1574M17.1205 9.23656C17.1205 9.67039 16.9335 10.1042 16.6998 10.3934C16.4661 10.6826 15.9987 10.8754 15.6248 10.8754H15.2041C14.7834 10.8754 14.4095 10.6826 14.1291 10.3934C13.8486 10.1042 13.7084 9.71858 13.7084 9.23656V5.95891C13.7084 5.52511 13.8486 5.09128 14.1291 4.80208C14.4095 4.51286 14.7367 4.32007 15.2041 4.32007H15.578C15.9987 4.32007 16.3726 4.51286 16.6531 4.80208C16.9335 5.09128 17.0737 5.47689 17.0737 5.95891",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23047 15.9912L5.07592 13.9094C6.26942 13.0369 7.70541 12.5662 9.1793 12.5662H13.6009C14.2488 12.5662 14.7755 13.0981 14.7755 13.7525C14.7755 14.4069 14.5997 14.6044 13.6009 14.9389L8.77598 15.5956",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44336 19.5351L6.14078 18.4137C6.38328 18.253 6.66744 18.1765 6.95539 18.1956L11.5418 18.9112C12.4625 18.9687 13.387 18.7965 14.2281 18.4137L20.7848 14.9925C21.679 14.5868 22.1223 13.5612 21.8116 12.6198C21.7055 12.3021 21.5388 12.0023 21.0501 12.2294L14.5999 14.4805",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileQuotas);
export default __webpack_public_path__ + "static/media/profile_quotas.6ae9038e4b5d73689bfa9e50b51e711e.svg";
export { ForwardRef as ReactComponent };